<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="7" :sm="8">
            <a-form-item label="Name" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterName" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="Phone" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enter phone number" v-model="queryParam.phone"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <a-form-item label="UserID" :labelCol="{ span: 6 }" :wrapperCol="{ span: 14, offset: 1 }">
              <a-input placeholder="Please enterUserID" v-model="queryParam.userId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">Search</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">Reset</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>

      <div class="table-operator" style="border-top: 5px">
        <a-button @click="handleAdd" type="primary" icon="plus">Add</a-button>
      </div>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">Edit</a>
          <a-divider type="vertical" />
          <a-popconfirm title="ConfirmDelete??" @confirm="() => handleDelete(record.id)">
            <a>Delete</a>
          </a-popconfirm>
        </span>
      </a-table>
    </div>

    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
      destroyOnClose
    >
      <a-form :form="form">
        <a-form-item label="Name" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['name', { initialValue: model.name, rules: [{ required: true, message: 'Please enterName' }] }]"
            placeholder="Please enterName"
          />
        </a-form-item>
        <a-form-item label="Phone" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['phone', { initialValue: model.phone, rules: [{ required: true, message: 'Please enter phone number' }] }]"
            placeholder="Please enter phone number"
          />
        </a-form-item>
        <a-form-item label="UserID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="[
              'userId',
              { initialValue: model.userId, rules: [{ required: true, message: 'Please enterUserID' }] },
            ]"
            placeholder="Please enterUserID"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getYunkePage, saveOrUpdateYunke, deleteYunke } from '@/webpublicapi/system'

export default {
  name: 'YunkeList',
  data() {
    return {
      form: this.$form.createForm(this),
      model: {},
      visible: false,
      confirmLoading: false,
      modalTitle: 'Add',
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 30,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' Total ' + total + ' records'
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      dataSource: [],
      // Query conditions
      queryParam: {
        name: '',
        phone: '',
        userId: '',
        pageNum: 1,
        pageSize: 30,
      },
      loading: false,
      // Table header
      columns: [
        { title: 'ID', align: 'left', dataIndex: 'id', width: '100px' },
        { title: 'Name', align: 'left', dataIndex: 'name', width: '160px' },
        { title: 'Phone', align: 'left', dataIndex: 'phone', width: '180px' },
        { title: 'UserID', align: 'left', dataIndex: 'userId', width: '140px' },
        {
          title: 'Action',
          dataIndex: 'action',
          align: 'center',
          width: '160px',
          scopedSlots: { customRender: 'action' },
        },
      ],
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: { xs: { span: 8 }, sm: { span: 5 } },
      wrapperCol: { xs: { span: 16 }, sm: { span: 19 } },
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    // Query
    searchQuery() {
      this.loadData(1)
    },
    // Reset
    searchReset() {
      this.queryParam = { name: '', phone: '', userId: '' }
      this.loadData(1)
    },
    // List loading
    loadData(arg) {
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      const params = this.getQueryParams()
      getYunkePage({
        name: params.name,
        phone: params.phone,
        userId: params.userId,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      })
        .then((res) => {
          const ok = res && (res.code === 1000 || res.code === 0)
          if (ok) {
            const data = res.data || {}
            const rows = data.rows || data.list || []
            const total = data.total != null ? data.total : data.list ? data.list.length : 0
            this.ipagination.total = total
            this.dataSource = rows
          } else {
            this.ipagination.total = 0
            this.dataSource = []
            this.$message.error(res.msg || 'Query failed')
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    getQueryParams() {
      const param = Object.assign({}, this.queryParam, this.isorter)
      param.pageNum = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      return filterObj(param)
    },
    handleTableChange(pagination) {
      this.ipagination = pagination
      this.loadData()
    },
    // Add new
    handleAdd() {
      this.model = {}
      this.modalTitle = 'Add'
      this.visible = true
      this.$nextTick(() => this.form.resetFields())
    },
    // Edit
    handleEdit(record) {
      this.model = Object.assign({}, record)
      this.modalTitle = 'Edit'
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue({ name: record.name, phone: record.phone, userId: record.userId, id: record.id })
      })
    },
    handleOk() {
      this.form.validateFields((err, values) => {
        if (err) return
        this.confirmLoading = true
        const payload = { ...values }
        if (this.model && this.model.id) {
          payload.id = this.model.id
        }
        saveOrUpdateYunke({ ...payload })
          .then((res) => {
            const ok = res && (res.code === 1000 || res.code === 0)
            if (ok) {
              this.$message.success(res.msg || 'Saved successfully')
              this.visible = false
              this.loadData()
            } else {
              this.$message.warning(res.msg || 'Save failed')
            }
            this.confirmLoading = false
          })
          .catch((e) => {
            this.confirmLoading = false
            this.$message.error(e.message)
          })
      })
    },
    handleCancel() {
      this.visible = false
    },
    // Delete (per API doc: id in query, userInfo in body)
    handleDelete(id) {
      deleteYunke(id, {}).then((res) => {
        const ok = res && (res.code === 1000 || res.code === 0)
        if (ok) {
          this.$message.success(res.msg || 'Deleted successfully')
          this.loadData()
        } else {
          this.$message.warning(res.msg || 'DeleteFailed')
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
